const uuidRegexpPattern =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
const uuidRegexp = new RegExp(uuidRegexpPattern, 'gi')

export default [
  {
    path: '',
    name: 'CRMService.Timeline',
    component: () => import('../views/list')
  },
  {
    name: 'CRMService.Timeline.Event',
    path: `:event_id(${uuidRegexpPattern})`,
    component: () => import('../views/event')
  }
]



// WEBPACK FOOTER //
// ./src/apps/crm/timeline/routes/index.js